const Pause = function() {
  return <></>;
};

export default Pause;
